import General from './DetailContent';

export default General;
